export default function ConnectorIcon() {
  return (
    <svg
      width='34px'
      height='11px'
      viewBox='0 0 34 11'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Page-1'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <g
          id='Vector'
          transform='translate(1.000000, 1.000000)'
          stroke='#849BB3'
          strokeWidth='1.8'
        >
          <path
            d='M2.55351296e-15,4.32177965 L4.321206,4.32177965 M26.791496,4.32177965 L31.112696,4.32177965 M14.692096,1.72904965 L11.235096,1.72904965 M14.692096,6.91449965 L11.235096,6.91449965 M11.235096,0.000569653325 L11.235096,8.64298965 L8.642416,8.64298965 C8.069046,8.65229965 7.499546,8.54740965 6.967116,8.33441965 C6.434686,8.12143965 5.949966,7.80462965 5.541196,7.40244965 C5.132426,7.00025965 4.807786,6.52074965 4.586196,5.99183965 C4.364596,5.46293965 4.250466,4.89522965 4.250466,4.32177965 C4.250466,3.74832965 4.364596,3.18061965 4.586186,2.65170965 C4.807786,2.12280965 5.132436,1.64329965 5.541196,1.24110965 C5.949966,0.838929653 6.434686,0.522109653 6.967116,0.309129653 C7.499546,0.0961496533 8.069046,-0.00874034668 8.642416,0.000569653325 L11.235096,0.000569653325 Z M19.877596,8.64298965 L19.877596,0.000569653325 L22.470296,0.000569653325 C23.043696,-0.00874034668 23.613196,0.0961496533 24.145596,0.309129653 C24.677996,0.522109653 25.162696,0.838929653 25.571496,1.24110965 C25.980296,1.64329965 26.304896,2.12280965 26.526496,2.65170965 C26.748096,3.18061965 26.862196,3.74832965 26.862196,4.32177965 C26.862196,4.89522965 26.748096,5.46293965 26.526496,5.99183965 C26.304896,6.52074965 25.980296,7.00025965 25.571496,7.40244965 C25.162696,7.80462965 24.677996,8.12143965 24.145596,8.33441965 C23.613196,8.54740965 23.043696,8.65229965 22.470296,8.64298965 L19.877596,8.64298965 Z'
            id='Shape'
          ></path>
        </g>
      </g>
    </svg>
  )
}
